@if (isAuthPage()) {
    <div class="auth-wrapper">
        <div class="auth-page">
            <router-outlet></router-outlet>
        </div>
        <div class="lang-switcher">
            <app-lang-switcher></app-lang-switcher>
        </div>
    </div>
} @else {
    <div class="app-wrapper">
        <app-sidebar [items]="sideBarItems()" (itemClicked)="onSidebarItemClick($event)">
            <app-lang-switcher></app-lang-switcher>
        </app-sidebar>

        <div class="app-main">
            @if (isMockMode) {
                <div class="mock-toolbar">
                    <div class="mock-toolbar__status">Mock mode</div>
                    <div class="mock-toolbar__user">
                        <span>User: {{ authService.getUser()?.userName || 'mock.user@tradgine.dev' }}</span>
                        <span>Org: {{ authService.getUser()?.orgName || 'Demo Organization' }}</span>
                    </div>
                    <button type="button" class="mock-toolbar__action" (click)="resetMockState()">
                        Reset state
                    </button>
                </div>
            }
            <app-navbar [username]="authService.getUser()?.userName"
                        [orgName]="authService.getUser()?.orgName"
                        [portal]="navbarService.portal()"
                        (logout)="logout()">
            </app-navbar>

            <ng-container #vcr></ng-container>

            <div class="content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
}
